import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, MessageCircle } from "lucide-react";
import { COMPANY, ASSETS, FOOTER_LINKS, waLink, WA_MESSAGES } from "@/lib/site";

const LinkCol = ({ title, links, testid }) => (
  <div data-testid={testid}>
    <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white/90">{title}</h4>
    <ul className="mt-4 space-y-3">
      {links.map((l) => (
        <li key={l.to}>
          <Link to={l.to} className="text-sm text-white/65 transition-colors hover:text-white">
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  const a = COMPANY.address;
  return (
    <footer data-testid="site-footer" className="bg-ink text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <img src={ASSETS.logo} alt="Miríade Turismo" className="h-14 w-14 rounded-full object-cover ring-2 ring-white/20" />
              <span className="font-heading text-lg font-bold">Miríade Turismo</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/65">{COMPANY.tagline}</p>
            <div className="mt-6 flex gap-3">
              <a href={COMPANY.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="rounded-full bg-white/10 p-2.5 transition-colors hover:bg-brand">
                <Instagram size={18} />
              </a>
              <a href={COMPANY.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="rounded-full bg-white/10 p-2.5 transition-colors hover:bg-brand">
                <Facebook size={18} />
              </a>
              <a href={waLink(WA_MESSAGES.default)} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="footer-whatsapp" className="rounded-full bg-white/10 p-2.5 transition-colors hover:bg-[#25D366]">
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-5">
            <LinkCol title="Institucional" links={FOOTER_LINKS.institucional} testid="footer-col-institucional" />
            <LinkCol title="Ajuda" links={FOOTER_LINKS.ajuda} testid="footer-col-ajuda" />
            <LinkCol title="Legal" links={FOOTER_LINKS.legal} testid="footer-col-legal" />
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white/90">Contato</h4>
            <ul className="mt-4 space-y-4 text-sm text-white/65">
              <li className="flex gap-3"><MapPin size={18} className="mt-0.5 shrink-0 text-brand-lilac" /><span>{a.street}<br />{a.city} - {a.state}, {a.zip}</span></li>
              <li className="flex gap-3"><Phone size={18} className="shrink-0 text-brand-lilac" /><a href={waLink(WA_MESSAGES.default)} className="hover:text-white">{COMPANY.phoneDisplay}</a></li>
              <li className="flex gap-3"><Mail size={18} className="shrink-0 text-brand-lilac" /><a href={`mailto:${COMPANY.email}`} className="break-all hover:text-white">{COMPANY.email}</a></li>
              <li className="flex gap-3"><Clock size={18} className="mt-0.5 shrink-0 text-brand-lilac" /><span>{COMPANY.hours}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-center text-xs text-white/45 sm:flex-row sm:text-left">
          <p>© {new Date().getFullYear()} Miríade Turismo. Todos os direitos reservados. CNPJ {COMPANY.cnpj}.</p>
          <div className="flex gap-5">
            <Link to="/termos-de-uso" className="hover:text-white">Termos de Uso</Link>
            <Link to="/politica-de-privacidade" className="hover:text-white">Privacidade</Link>
            <Link to="/seguranca" className="hover:text-white">Segurança</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
